import { RootState } from '../store'

export const paymentsSelector = (state: RootState) => state.payments
